import { useEffect, useRef } from "react";
import { DEFAULT_PAGINATION_SIZE } from "components/common/Constants";

/** Refresh loaded library pages only while receipts are queued or processing. */
export function useReceiptPolling(
  refetch: (variables?: {
    first: number;
    after: undefined;
  }) => Promise<unknown>,
  receiptCount: number,
  loading: boolean,
  hasPendingReceipts: boolean,
) {
  const latest = useRef({ refetch, receiptCount, loading });
  latest.current = { refetch, receiptCount, loading };

  const inFlight = useRef(false);
  useEffect(() => {
    if (!hasPendingReceipts) return;

    const refresh = async () => {
      if (document.hidden || inFlight.current || latest.current.loading) return;
      inFlight.current = true;
      try {
        await latest.current.refetch({
          first: Math.max(DEFAULT_PAGINATION_SIZE, latest.current.receiptCount),
          after: undefined,
        });
      } catch (error) {
        console.error("Unable to refresh receipt progress:", error);
      } finally {
        inFlight.current = false;
      }
    };
    const timer = window.setInterval(refresh, 10000);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, [hasPendingReceipts]);
}
